<script setup>
import { trans } from '@elements/translation';

defineProps({
  shortcuts: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <div
    class="pagination-shortcuts"
  >
    <p class="pagination-shortcuts__note">
      {{ trans('global.pagination.shortcuts_note') }}
    </p>

    <div class="pagination-shortcuts__content">
      <a
        v-for="shortcut in shortcuts"
        :key="`page-shortcut-${shortcut}`"
        class="pagination-shortcuts__link"
      >
        {{ shortcut }}
      </a>
    </div>
  </div>
</template>
